import { AbstractControl } from '@angular/forms';
import { TypeaheadSelectGroupValue } from '@yourcause/common/core-forms';
import { ValidatorMessageObj } from '@yourcause/common/form-control-validation';

export function PicklistGroupValidator (mustAddTo100: boolean) {
  return (control: AbstractControl) => {
    const values = control.value as TypeaheadSelectGroupValue[] ?? [];
    if (values.length > 0) {
      const percentageError: ValidatorMessageObj = {
        perecentError: {
          i18nKey: 'common:textMustAddUpTo100',
          defaultValue: 'Must add up to 100%'
        }
      };
      const negativeError: ValidatorMessageObj = {
        perecentError: {
          i18nKey: 'common:textCannotContainNegativeValues',
          defaultValue: 'Cannot contain negative values'
        }
      };
      if (values.some(val => val.numericValue < 0)) {
        return negativeError;
      } else if (mustAddTo100) {
        const sumOfFields = values.reduce((acc, val) => {
          return acc + +(val.numericValue || 0);
        }, 0);
        const valid = sumOfFields === 100;
        
        return valid ? null : percentageError;
      }
    }

    return null;
  };
}
